import { API_NETWORK_ERROR } from "../../utils/constants";

const responseInterceptorFailure = (error) => {
    console.log("...responseInterceptorFailure", error);
    if (error.message === 'Network Error') {
        return { hasError: true, message: API_NETWORK_ERROR };
    } else if (!error.response) {
        return { hasError: true, message: API_NETWORK_ERROR, SpecialMessage: 'Error is undefined' };
    }


    // else if (!error.status) {
    //   { hasError: true, message: API_NETWORK_ERROR };
    // }



    const { status, data } = error.response;
    let errorResponse = {};
    if (status === 400) {
        let message = 'Invalid request.';
        if (data && typeof data === 'object' && typeof data.CustomMessage === 'string' && data.CustomMessage.trim()) {
            message = data.CustomMessage.trim();
        } else if (typeof data === 'string' && data.trim()) {
            message = data.trim();
        } else if (data && typeof data === 'object') {
            const parts = [];
            if (typeof data.message === 'string' && data.message.trim()) {
                parts.push(data.message.trim());
            } else if (typeof data.error === 'string' && data.error.trim()) {
                parts.push(data.error.trim());
            }
            if (Array.isArray(data.details)) {
                const detailText = data.details
                    .filter((d) => typeof d === 'string')
                    .map((d) => d.trim())
                    .filter(Boolean)
                    .join('. ');
                if (detailText) parts.push(detailText);
            }
            message =
                parts.length === 0
                    ? 'Invalid request.'
                    : parts.length === 1
                        ? parts[0]
                        : `${parts[0]}: ${parts.slice(1).join('. ')}`;
        }
        errorResponse = { hasError: true, message, status };
    } else if (status === 401) {
        localStorage.clear();
        window.location.href = '/login';
        errorResponse = { hasError: true, message: "Authentication failed!", status: status };
    } else if (status === 403) {
        errorResponse = { hasError: true, message: "Authentication failed!", status: status };
    } else if (status === 300) {
        errorResponse = { hasError: true, message: "Authentication failed!", status: status };
    } else if (status === 301) {
        errorResponse = { hasError: true, message: "Authentication failed!", status: status };
    } else if (status === 500) {
        errorResponse = { hasError: true, message: "Authentication failed!", status: status };
    } else if (status === 503 && data.error === 'Request timed out') {
        errorResponse = { hasError: true, message: 'Request timed out', status: status };
    } else {
        const backendMessage =
            data &&
            typeof data === 'object' &&
            typeof data.message === 'string' &&
            data.message.trim()
                ? data.message.trim()
                : null;
        errorResponse = {
            hasError: true,
            message: backendMessage || "Authentication failed!",
            ResponseInterceptor: "Check response interceptor error block",
            status: status,
        };
        if (data && typeof data === 'object' && data !== null) {
            if (data.existing_job_id != null) {
                errorResponse.existing_job_id = data.existing_job_id;
            }
            if (data.job_id != null) {
                errorResponse.job_id = data.job_id;
            }
        }
    }
    return errorResponse;
};

export default responseInterceptorFailure;
